/** Resolve /uploads/... paths against the Portal API host (same fallback as api.js). */
export function getApiOrigin() {
  const base =
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'production'
      ? 'https://chesiwms-production-1eb5.up.railway.app/api'
      : 'http://localhost:5000/api');
  return base.replace(/\/?api\/?$/i, '');
}

export function getSiteOrigin() {
  const base =
    process.env.REACT_APP_SITE_URL ||
    (process.env.NODE_ENV === 'production'
      ? 'https://www.chesimobile.com'
      : 'http://localhost:3000');
  return base.replace(/\/$/, '');
}

export function resolveUploadUrl(url) {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) {
    try {
      const { pathname } = new URL(url);
      if (pathname.startsWith('/assets/')) {
        return `${getSiteOrigin()}${pathname}`;
      }
    } catch {
      // fall through
    }
    return url;
  }

  let path = url;
  if (path.startsWith('/assets/images/products/')) {
    path = path.replace(
      /^(\/assets\/images\/products\/\d+)-\d+-(\d+)-(.+)$/,
      '$1-$2-$3'
    );
    path = path.replace(
      /^(\/assets\/images\/products\/\d+)-([A-Za-z].*)$/,
      '$1-0-$2'
    );
  }

  if (path.startsWith('/assets/')) {
    return `${getSiteOrigin()}${path}`;
  }
  const origin = getApiOrigin();
  return `${origin}${path.startsWith('/') ? '' : '/'}${path}`;
}
